"use client";

import { c as _c } from "react/compiler-runtime";
import { CustomImage } from "@repo/design-system/components/ui/custom-image";
import { cn } from "@repo/design-system/utils/cn";
import { X } from "lucide-react";
import { useCallback, useEffect, useRef, useState } from "react";
import Chat from "~/components/icons/chat-eon";
import { ApplyButton } from "~/components/ui/apply-button-eon";
import { useOutsideClick } from "~/hooks/use-outside-click";
import { useLanguage } from "~/translations/loader/use-language";
import type { Job } from "~/types/job";
interface StickyContactEconProps {
  job: Job;
}
export default function StickyContactEcon(t0) {
  const $ = _c(47);
  const {
    job
  } = t0;
  const t = useLanguage();
  const [showDetails, setShowDetails] = useState(false);
  const containerRef = useRef(null);
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = () => {
      setShowDetails(false);
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const handleClose = t1;
  const outsideClickRef = useOutsideClick(handleClose);
  let t2;
  let t3;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = () => {
      const container = containerRef.current;
      if (!container) {
        return;
      }
      const handler = _temp;
      container.addEventListener("touchmove", handler, {
        passive: false
      });
      return () => {
        container.removeEventListener("touchmove", handler);
      };
    };
    t3 = [];
    $[1] = t2;
    $[2] = t3;
  } else {
    t2 = $[1];
    t3 = $[2];
  }
  useEffect(t2, t3);
  let t4;
  if ($[3] !== outsideClickRef) {
    t4 = node => {
      outsideClickRef.current = node;
      containerRef.current = node;
    };
    $[3] = outsideClickRef;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  const t5 = showDetails ? "w-72 opacity-100 lg:w-96" : "h-12 w-12 rounded-lg opacity-90 hover:opacity-100 md:h-20 md:w-20";
  let t6;
  if ($[5] !== t5) {
    t6 = cn("relative bg-secondary shadow-xl transition-all duration-500", t5);
    $[5] = t5;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  const t7 = showDetails ? "pointer-events-none absolute opacity-0" : "opacity-100";
  let t8;
  if ($[7] !== t7) {
    t8 = cn("flex h-full w-full cursor-pointer items-center justify-center text-white transition-opacity md:hover:text-primary", t7);
    $[7] = t7;
    $[8] = t8;
  } else {
    t8 = $[8];
  }
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = () => setShowDetails(true);
    $[9] = t9;
  } else {
    t9 = $[9];
  }
  let t10;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <Chat className="h-8 w-8 md:h-14 md:w-14" />;
    $[10] = t10;
  } else {
    t10 = $[10];
  }
  let t11;
  if ($[11] !== showDetails || $[12] !== t8) {
    t11 = <button aria-expanded={showDetails} aria-label="Contact" className={t8} onClick={t9} type="button">{t10}</button>;
    $[11] = showDetails;
    $[12] = t8;
    $[13] = t11;
  } else {
    t11 = $[13];
  }
  const t12 = t.jobad_stickyContact_close_title;
  const t13 = showDetails ? "opacity-100" : "pointer-events-none opacity-0";
  let t14;
  if ($[14] !== t13) {
    t14 = cn("absolute top-2 right-2 cursor-pointer text-white transition-opacity hover:text-primary", t13);
    $[14] = t13;
    $[15] = t14;
  } else {
    t14 = $[15];
  }
  let t15;
  if ($[16] === Symbol.for("react.memo_cache_sentinel")) {
    t15 = <X className="m-2 size-6" />;
    $[16] = t15;
  } else {
    t15 = $[16];
  }
  let t16;
  if ($[17] !== t.jobad_stickyContact_close_title || $[18] !== t14) {
    t16 = <button aria-label={t12} className={t14} onClick={handleClose} type="button">{t15}</button>;
    $[17] = t.jobad_stickyContact_close_title;
    $[18] = t14;
    $[19] = t16;
  } else {
    t16 = $[19];
  }
  const t17 = showDetails ? "p-6 opacity-100" : "pointer-events-none h-0 overflow-hidden opacity-0";
  let t18;
  if ($[20] !== t17) {
    t18 = cn("grid transition-opacity duration-300", t17);
    $[20] = t17;
    $[21] = t18;
  } else {
    t18 = $[21];
  }
  let t19;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t19 = <div className="flex justify-center"><div className="relative aspect-square h-auto w-44 rounded-full lg:w-60"><CustomImage alt="Recruiting Team" blur={true} className="rounded-full object-cover" fill={true} sizes="(min-width: 1024px) 240px, 176px" src="images/recruiter/subclients/econ/default.jpg" /></div></div>;
    $[22] = t19;
  } else {
    t19 = $[22];
  }
  let t20;
  if ($[23] !== t.jobad_stickyContact_econ_title) {
    t20 = <div className="flex w-full justify-end"><h2 className="my-2 text-right font-bold text-2xl text-white md:text-3xl lg:text-4xl">{t.jobad_stickyContact_econ_title}</h2></div>;
    $[23] = t.jobad_stickyContact_econ_title;
    $[24] = t20;
  } else {
    t20 = $[24];
  }
  let t21;
  if ($[25] !== t.jobad_stickyContact_econ_text) {
    t21 = <div className="space-y-2 py-2 text-white" dangerouslySetInnerHTML={{
      __html: t.jobad_stickyContact_econ_text
    }} />;
    $[25] = t.jobad_stickyContact_econ_text;
    $[26] = t21;
  } else {
    t21 = $[26];
  }
  let t22;
  if ($[27] !== job) {
    t22 = job.data.applicationUrl && job.data.applicationUrl.length > 2 && <ApplyButton className="hover:bg-brand" job={job} variant="econ" />;
    $[27] = job;
    $[28] = t22;
  } else {
    t22 = $[28];
  }
  let t23;
  if ($[29] !== job) {
    t23 = job.data.applicationUrlDirect && <ApplyButton className="hover:bg-brand" direct={true} job={job} variant="econ" />;
    $[29] = job;
    $[30] = t23;
  } else {
    t23 = $[30];
  }
  let t24;
  if ($[31] !== t22 || $[32] !== t23) {
    t24 = <div className="mt-4 flex flex-col space-y-2 font-bold">{t22}{t23}</div>;
    $[31] = t22;
    $[32] = t23;
    $[33] = t24;
  } else {
    t24 = $[33];
  }
  let t25;
  if ($[34] !== t18 || $[35] !== t20 || $[36] !== t21 || $[37] !== t24) {
    t25 = <div className={t18}>{t19}{t20}{t21}{t24}</div>;
    $[34] = t18;
    $[35] = t20;
    $[36] = t21;
    $[37] = t24;
    $[38] = t25;
  } else {
    t25 = $[38];
  }
  let t26;
  if ($[39] !== t11 || $[40] !== t16 || $[41] !== t25 || $[42] !== t6) {
    t26 = <div className={t6}>{t11}{t16}{t25}</div>;
    $[39] = t11;
    $[40] = t16;
    $[41] = t25;
    $[42] = t6;
    $[43] = t26;
  } else {
    t26 = $[43];
  }
  let t27;
  if ($[44] !== t26 || $[45] !== t4) {
    t27 = <div aria-label="Contact" className="fixed right-0 bottom-10 z-50 print:hidden" ref={t4} role="complementary">{t26}</div>;
    $[44] = t26;
    $[45] = t4;
    $[46] = t27;
  } else {
    t27 = $[46];
  }
  return t27;
}
function _temp(e) {
  e.preventDefault();
}